import { Fragment, FunctionComponent } from "react";
import * as sentry from "@sentry/react";
import { BrowserRouter } from "react-router-dom";
import { ClientApplication } from "@edgetier/client-components";
import { QueryClientProvider, QueryClient } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { showServerError } from "utilities/show-server-error";
import { Toaster } from "react-hot-toast";
import Routes from "components-for/application/routes";
import TrackPageChanges from "./track-page-changes";
import { IProps } from "./application.types";
import { shouldRequestRetry } from "@edgetier/utilities";
import "./application.scss";
import ErrorFallback from "components-for/errors/error-fallback";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            onError: showServerError,
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            retry: shouldRequestRetry,
        },
    },
});

const Application: FunctionComponent<IProps> = () => {
    return (
        <Fragment>
            <Toaster position="bottom-right" toastOptions={{ style: { backgroundColor: "#34495e", color: "white" } }} />

            <QueryClientProvider client={queryClient}>
                <ReactQueryDevtools
                    initialIsOpen={false}
                    position="top-left"
                    toggleButtonProps={{ className: "react-query-devtools__button" }}
                />
                <BrowserRouter>
                    <TrackPageChanges />
                    <ClientApplication>
                        <Routes />
                    </ClientApplication>
                </BrowserRouter>
            </QueryClientProvider>
        </Fragment>
    );
};

export default sentry.withErrorBoundary(Application, {
    fallback: ErrorFallback,
    showDialog: true,
});
